export const scrollYToSmooth = (positionY = 0, ms = 500) => {
  if (isNaN(positionY)) {
    throw 'PositionY must be a number';
  }

  if (positionY < 0) {
    throw 'PositionY must be a positive number';
  }

  if (isNaN(ms)) {
    throw 'time must be a number';
  }

  if (ms < 0) {
    throw 'time must be a positive number';
  }

  let startTime = null;
  const currentPos = window.scrollY || window.screenTop;

  window.requestAnimationFrame(function step(currentTime) {
    startTime = startTime ? startTime : currentTime;
    const isScrollDown = currentPos < positionY;

    let progress = currentTime - startTime;

    isScrollDown
      ? window.scrollTo(0, ((positionY - currentPos) * progress) / ms + currentPos)
      : window.scrollTo(0, currentPos - ((currentPos - positionY) * progress) / ms);

    if (progress < ms) {
      window.requestAnimationFrame(step);
    } else {
      window.scrollTo(0, positionY);
    }
  });
};
